import React from 'react';
import { Path, Circle, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const DotIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 4 4"
    fill="none"
    {...props}
  >
    <Circle cx="2" cy="2" r="2" fill={color} />
  </Svg>
);

DotIcon.displayName = 'DotIcon';
